
import React, { useState, useEffect } from 'react';
import CategoriesList from '../../components/Category/CategoriesList';
import SeriesList from '../../components/Series/SeriesList';
import styles from './SeriesBrowser.module.css';
import Streaming from '../../components/Streaming';
import { useCategoryParams } from '../../hooks/useCategoryParams';

function SeriesBrowser() {
    const [params, actions] = useCategoryParams();
    const [showSeries, setShowSeries] = useState(false);
    const [isMobile, setIsMobile] = useState(false);

    // Handle window resize for responsive behavior
    useEffect(() => {
        const checkMobile = () => {
            const mobile = window.innerWidth <= 768;
            setIsMobile(mobile);
        };

        checkMobile();
        window.addEventListener('resize', checkMobile);

        return () => {
            window.removeEventListener('resize', checkMobile);
        };
    }, []);

    // Show series panel when a category is selected
    // Note: showSeries is intentionally excluded - we only react to categoryId changes
    useEffect(() => {
        if (params.categoryId) {
            setShowSeries(true);
        } else {
            setShowSeries(false);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [params.categoryId]);

    const handleCloseSeries = () => {
        setShowSeries(false);

        // On mobile, clear the category to go back to categories list
        if (isMobile) {
            actions.clearCategoryId();
        }
    };

    // Determine what to show based on screen size and state
    const showSeriesInLeftPanel = params.categoryId && showSeries && isMobile;
    const showSeriesInMiddlePanel = params.categoryId && showSeries && !isMobile;

    // Render left panel content
    const renderLeftPanel = () => {
        if (showSeriesInLeftPanel) {
            return <SeriesList onClose={handleCloseSeries} />;
        }
        return <CategoriesList />;
    };

    // Render middle panel content
    const renderMiddlePanel = () => {
        if (showSeriesInMiddlePanel) {
            return (
                <div className={styles.box}>
                    <SeriesList onClose={handleCloseSeries} />
                </div>
            );
        }
        return null;
    };

    return (
        <div className={styles.boxcontainer}>
            {/* Left panel - Categories or Series (mobile) */}
            <div className={`${styles.box} ${showSeriesInLeftPanel ? styles.seriesPanel : ''}`}>
                {renderLeftPanel()}
            </div>

            {/* Middle panel - Series (desktop) */}
            {renderMiddlePanel()}

            {/* Right panel - Streaming */}
            <div className={`${styles.box} ${styles.streamingPanel} ${!showSeriesInMiddlePanel ? styles.expanded : ''}`}>
                <Streaming />
            </div>
        </div>
    );
}

export default SeriesBrowser;